import { ArrowRight, BookOpen, Clock, FileText } from "@phosphor-icons/react";
import type { Article, ComicEdition, ComicIssue } from "../types";
import { ArticleMedia } from "./ArticleMedia";

function sourceLabel(count: number) {
  return `${count} ${count === 1 ? "źródło" : count < 5 ? "źródła" : "źródeł"}`;
}

export function NewsstandHero({
  lead,
  starters,
  comic,
  issue,
  onOpenArticle,
  onOpenComic,
}: {
  lead: Article;
  starters: Article[];
  comic: ComicEdition | null | undefined;
  issue: ComicIssue | null;
  onOpenArticle: (article: Article) => void;
  onOpenComic: () => void;
}) {
  const cover = issue?.coverImageUrl ?? comic?.coverImageUrl;

  return <section className="newsstand" aria-label="Najważniejsze wiadomości i dzisiejszy KOMIX">
    <article className="newsstand__lead">
      <p className="newsstand__flag"><span /> Najważniejsze teraz</p>
      <h1>{lead.title}</h1>
      <p className="newsstand__summary">{lead.summary}</p>
      <div className="newsstand__meta">
        <span><Clock weight="bold" /> Aktualizacja {lead.publishedAt}</span>
        <span><FileText weight="bold" /> {sourceLabel(lead.sources.length)}</span>
      </div>
      <button className="primary-action" type="button" onClick={() => onOpenArticle(lead)}>
        Czytaj temat <ArrowRight weight="bold" />
      </button>
    </article>

    <button className="newsstand__visual" type="button" onClick={() => onOpenArticle(lead)} aria-label={`Otwórz temat: ${lead.title}`}>
      <ArticleMedia article={lead} priority sizes="(min-width: 1280px) 25vw, (min-width: 900px) 50vw, 100vw" caption={false} />
    </button>

    <section className="starter" aria-labelledby="starter-title">
      <h2 id="starter-title"><Clock weight="bold" /> 5 minut na start</h2>
      <div className="starter__list">
        {starters.slice(0, 3).map(article => <button key={article.id} type="button" onClick={() => onOpenArticle(article)}>
          <ArticleMedia article={article} compact sizes="112px" caption={false} />
          <span>
            <small>{article.category}</small>
            <strong>{article.title}</strong>
            <p>{article.summary}</p>
          </span>
          <ArrowRight className="starter__arrow" weight="bold" />
        </button>)}
      </div>
    </section>

    <section className="comic-cover" aria-labelledby="comic-cover-title">
      <h2 id="comic-cover-title">Dzisiejszy KOMIX</h2>
      <button type="button" onClick={onOpenComic} disabled={!comic} aria-label={comic ? `Otwórz KOMIX numer ${comic.number}` : "KOMIX w przygotowaniu"}>
        {cover
          ? <img src={cover} alt={issue ? `Okładka KOMIX-u: ${issue.coverTitle}` : `Okładka KOMIX-u numer ${comic?.number}`} width="1200" height="1600" />
          : <div className="comic-cover__empty"><BookOpen weight="duotone" /><span>KOMIX w przygotowaniu</span></div>}
        <span className="comic-cover__bar">
          <b>{comic ? `KOMIX NR ${String(comic.number).padStart(3, "0")}` : "KOMIX"}</b>
          <BookOpen weight="bold" />
        </span>
      </button>
    </section>
  </section>;
}
